export default __webpack_public_path__ + "static/media/bed.b96eddb9.svg";